export default "__VITE_ASSET__0efd1527__"